<template>
  <div class="barchart-drilldown-wrapper">
    <dynamic-chart-component
      v-if="chart_config"
      el="barchart-tes-001"
      :config="chart_config"
    />
  </div>
</template>

<script>
import Highcharts from "highcharts/highcharts.js";
import dynamic_chart from "@/views/components/chart/dynamic_chart.vue";
import moment from "moment";
export default {
  name: "bar_chart_drilldown",
  components: {
    "dynamic-chart-component": dynamic_chart,
  },
  props: {
    series: {
      type: [Array, Boolean],
      default: false,
    },
    subseries: {
      type: [Array, Boolean],
      default: false,
    },
    groups: {
      type: [Array, Boolean],
      default: false,
    },
    topik: {
      type: Array,
    },
  },
  data() {
    return {
      chart_config: null,
    };
  },
  mounted: function () {
    let self = this;
    var chart = {
      type: "column",
      backgroundColor: "transparent",
      events: {
        drilldown: function (e) {
          if (!e.seriesOptions) {
            let name_index = e.point.getLabelConfig();
            name_index = name_index["key"];
            var chart = this;

            for (let i = 0; i < self.subseries[name_index].length; i++) {
              chart.addSingleSeriesAsDrilldown(
                e.point,
                self.subseries[name_index][i]
              );
            }
            chart.applyDrilldown();
          }
        },
      },
    };

    var plotOptions = {
      column: {
        stacking: "normal",
      },
      series: {
        cursor: "pointer",
        point: {
          events: {
            click: function (event) {
              if (event.point.name != null) {
                let start = "";
                let end = "";
                let params = {};
                let idTopik;

                start = moment(self.$route.query.from).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
                end = moment(self.$route.query.to).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
                let sentimen;
                if (event.point.series.name == "Positif") {
                  sentimen = btoa(1);
                } else if (event.point.series.name == "Netral") {
                  sentimen = btoa(0);
                } else if (event.point.series.name == "Negatif") {
                  sentimen = btoa(-1);
                }

                self.topik
                  .filter((val) => val.nama == event.point.name)
                  .map((item) => {
                    idTopik = item.id;
                  });

                params = {
                  from: start,
                  to: end,
                  sentiments: sentimen,
                  topic_selected: btoa(idTopik),
                };

                self.$router.push({ path: "/posts", query: params });
              }
            },
          },
        },
      },
    };
    var title = {
      text: "",
      style: {
        fontSize: "18px",
      },
      align: "left",
    };
    var subtitle = {
      text: "",
      style: {
        fontSize: "12px",
      },
      align: "left",
    };

    var yAxis = {
      gridLineWidth: 1,
      title: "",
      lineWidth: 1,
    };
    var xAxis = {
      type: "category",
    };

    var tooltip = {
      formatter: function () {
        return (
          '<span style="font-size:11px; font-weight: bold">' +
          this.key +
          "</span>: <br>" +
          this.series.name +
          "</span>: <b>" +
            Highcharts.numberFormat(Math.round(this.point.y, 1), 0, ',', ',') +
          "</b><br/>"
        );
      },
    };

    var series;
    if (this.series == false) {
      series = [];
    } else {
      series = this.series;
    }

    var drilldown = {
      series: [],
    };

    var legend = {
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom",
      padding: 0,
      symbolPadding: 0,
      symbolWidth: 20,
      margin: 10,
      x: 0,
      y: 0,
      reversed: false,
    };
    var credits = {
      text: "",
      href: false,
      style: {
        color: "#999999",
        cursor: false,
        fontSize: "10px",
      },
      position: {
        align: "left",
        x: 10,
        y: -70,
      },
    };
    var exporting = {
      allowHTML: true,
      enabled: true,
      filename: "online-media-monitoring-barchart-grup-topik",
      buttons: {
        contextButton: {
          menuItems:
            "printChart separator downloadPNG downloadJPEG downloadSVG".split(
              " "
            ),
        },
      },
    };
    var responsive = {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              enabled: true,
            },
          },
        },
      ],
    };
    var highchartsOptions = Highcharts.setOptions({
      lang: {
        decimalPoint: ".",
        thousandsSep: "'",
        months: [
          "Januari",
          "Februari",
          "Maret",
          "April",
          "Mei",
          "Juni",
          "Juli",
          "Agustus",
          "September",
          "Oktober",
          "November",
          "Desember",
        ],
        weekdays: [
          "Minggu",
          "Senin",
          "Selasa",
          "Rabu",
          "Kamis",
          "Jumat",
          "Sabtu",
        ],
        shortMonths: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "Mei",
          "Jun",
          "Jul",
          "Agu",
          "Sep",
          "Okt",
          "Nov",
          "Des",
        ],
        contextButtonTitle: "Drucken, Download, Export",
        downloadJPEG: "Download JPEG Image",
        downloadPNG: "Download PNG Image",
        downloadSVG: "Download SVG Vektor Image",
        downloadXLS: "Download XLS",
        printChart: "Print Chart",
        viewData: "Datentabelle ein-/ausblenden",
        resetZoom: "Zoom zurücksetzen",
        resetZoomTitle: "Zoom zurücksetzen",
        drillUpText: "< Kembali",
        backgroundColor: "transparent",
      },
    });
    var colors = [
      "#878787",
      "#B5B5B5",
      "#E39E00",
      "#CD3700",
      "#8B0000",
      "#3CA433",
      "#a2c510",
      "#FFED00",
      "#00B4E8",
      "#0064e6",
      "#27408B",
    ];
    var json = {};
    json.chart = chart;
    json.plotOptions = plotOptions;
    json.title = title;
    json.subtitle = subtitle;
    json.yAxis = yAxis;
    json.xAxis = xAxis;
    json.tooltip = tooltip;
    json.series = series;
    json.drilldown = drilldown;
    json.legend = legend;
    json.credits = credits;
    json.exporting = exporting;
    json.responsive = responsive;
    json.highchartsOptions = highchartsOptions;
    json.colors = colors;

    this.chart_config = json;
  },
};
</script>